import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import { ResponseType } from "../../Types/ServicesType/servicesType";
import { getRadioPayloadType, RadiologyField, RadiologyItemType, Template} from "./Type";
import instance from "@services/services";
const { clinicId } = getConstants()
type RadiologyListResponseType = {

    id: number;
    name: string;
};
const {RadiologyApi }=api
export const getRadiologyListService = async (body: getRadioPayloadType): Promise<ResponseType<RadiologyListResponseType>|any> => {
   const result =await instance.post(`${RadiologyApi.getRadiologyList}`, body)
   return result?.data?.response
};



export const getRadiologyItemService = async (id:string): Promise<ResponseType<RadiologyItemType[]|null>|any> => {
    const result =await instance.get(`${RadiologyApi.getRadiologyitemList}${id}?clinicId=${clinicId}`)
    return result?.data?.response
}

export const findRadiology=async(id:number):Promise<ResponseType<{totalCount:number,items:RadiologyField[]}>>=>{
    const body={
        radiologyId: id,
        pageNo: 0,
        sortOrder: "asc",
        pageNumber: 0,
        pageSize: 25,
        clinicId
    }
    const result =await instance.post(`${RadiologyApi.findRadiology}`,body)
    return result?.data?.response
}

export const getRadioTemplate=async(body:{templateName:string,clincid:number,packageMappingId:number,labRequestId:number,cptId:number}):Promise<ResponseType<Template[]>>=>{
    const result =await instance.post(`${RadiologyApi.getTemplate}`,body)
    return result?.data?.response
}

export const saveorUpdateRadiology=async(body:any)=>{
    const result =await instance.post(`${RadiologyApi.saveOrUpdateRadiology}`,body)
    return result?.data
}

export const getLabUploadedFiles = async (labId:number):Promise<ResponseType<{ fileName: string; resultId: number }[]>> => {
    const result = await instance.get(`${RadiologyApi.getuploadfiles}${labId}?clinicId=${clinicId}`);
    return result.data
};

export const getUploadFile = async (fileId:number):Promise<ResponseType<string>>=>{
   const result = await instance.get(`${RadiologyApi.getUploadedFile}${fileId}?clinicId=${clinicId}`)
   return result.data
}
export const printReport = async (Id:number):Promise<ResponseType<string>>=>{
   const result = await instance.get(`${RadiologyApi.getPrint}${Id}?clinicId=${clinicId}`)
   return result.data
}




